export default __webpack_public_path__ + "static/media/Apartment.c5697561.svg";